module.exports = __webpack_public_path__ + "media/images/loader-180407b5135c82bc504d09685a904933.svg";